let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fgtb2")).then(() => parcelRequire('3CQDq'));